<template>
  <section :class="$route.name == 'root' ? 'home' : ''" class="content">
    <div class="inner">
      <span v-html="page.main_text" v-if="isHomePage"></span>

      <h1 v-if="isPropertiesPage">Our current developments</h1>
      <h1 class="leftalign" v-if="page.heading">{{ page.heading }}</h1>

      <div class="generic" v-if="!isHomePage && !isPropertiesPage">
        <div class="left" v-html="page.main_text" :class="page.subs && page.subs.length ? '' : 'full'"></div>
        <div class="right" v-if="page.subs && page.subs.length">
          <div class="links">
            <h3>More information</h3>
            <page-link v-for="sub in page.subs" :key="sub.ItemID" :to="sub.url">
              <font-awesome-icon icon="chevron-right" />
              {{ sub.name }}
            </page-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters } from "vuex"

export default {
  computed: {
    ...mapState(["page"]),
    ...mapGetters(["isHomePage", "isPage", "isPropertiesPage", "isBuyPage"])
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
  text-align: center;
  padding: 4rem 0;
  line-height: 1.8;
  font-size: 1.8rem;
}

.content.home {
  padding-bottom: 7rem;
}

.content >>> p {
  max-width: 1000px;
  margin: auto;
}

.content >>> h1 {
  margin-bottom: 2rem;
}

.content >>> .large {
  font-size: 2rem;
}

.content >>> ul,
.content >>> ol {
  padding-top: 1rem;
  padding-left: 2rem;
}

.content >>> h2 {
  font-size: 2rem;
  color: #253e52;
  margin-bottom: 1rem;
}

.generic {
  display: table;
  width: 100%;
  text-align: left;
}

.generic >>> p {
  max-width: none;
  padding-top: 0;
  margin-top: 0;
  margin-bottom: 2.5rem;
}

.links {
  background: #f7f7f7;
  padding-bottom: 2rem;
}

.leftalign {
  text-align: left;
}

.links a {
  display: block;
  margin: 0 2.5rem;
  margin-top: 1rem;
}

.links h3 {
  background: #d1ae54;
  color: #fff;
  padding: 1rem 2.5rem;
  margin-bottom: 2rem;
  font-weight: normal;
}

.links a svg {
  margin-right: 0.5rem;
  color: #455c6e;
}

.left {
  margin-bottom: 3rem;
}

.left.full {
  width: 100%;
  columns: 2;
  column-gap: 6rem;
}

@media screen and (max-width: 950px) {
  .left.full {
    columns: unset;
  }
}
</style>
